/* istanbul ignore file */
import { Link } from 'react-router-dom';
import { useBudgetUrl } from '../route/route';

const BudgetLink = ({ id, name }: { id: StringOrNumber; name: string }) => {
  const { getSingleEntityUrl } = useBudgetUrl();

  return <Link to={getSingleEntityUrl(id)}>{name}</Link>;
};

export default BudgetLink;
